<i18n src="@/locales/modules/TodoListTranslate.json"></i18n>

<template>
	<div id="todo-list" :class="{ 'data-list-container': !isQuickMode }" :key="todoListFilterFlagValue || 'default'">
		<todo-list-form-sidebar
			:categoryId="categoryId"
			:data="todoFormDialogData"
			:parent="parentData"
			:isSidebarActive="isTodoFormDialogActive"
			@closeSidebar="toggleDataSidebar"
			@refetchDataList="handleRefectchDataList"
			@onCreateOrUpdateSuccess="onCreateOrUpdateTodoItemSuccess"
			:todoFilterFlagValue="todoListFilterFlagValue"
		/>
		<todo-detail-sidebar
			v-if="isDetailTodoDialogActive"
			:categoryId="categoryId"
			:data="detailTodoDialogData"
			:isSidebarActive="isDetailTodoDialogActive"
			@editData="editData"
			@onClickEdit="editData"
			@onSetStatusTodo="setStatusTodo"
			@closeSidebar="toggleDetailSidebar"
			@onClickWatcher="handleClickWatcher"
			@onClickReminder="handleClickReminder"
			@onClickCancel="handleClickCancelTodoItem"
			@onClickReject="handleClickRejectTodoItem"
			@onClickCreateRequest="handleClickCreateRequest"
			@onSubmitReport="handleUpdateReportFormTodoItem"
			@onCompleteReport="handleOnCompleteReportTodoItem"
			@onClickToggleScheduleTodo="handleToggleScheduleTodo"
			@onCreateOrUpdateSuccess="onCreateOrUpdateTodoItemSuccess"
			@onClickQuickConfigChildren="handleClickQuickConfigChildrenTodoItem"
			@onClickSettingTimeRepeater="handleSettingTimeRepeater"
		/>

		<request-form-dialog
			v-if="isShowRequestFormDialogMixin"
			v-model="activeRequestMixin"
			:stepsData="stepsDataMixin"
			:activeStepId="activeStepIdMixin"
			:requestTypes="requestTypesMixin"
			:relationsData="relationsData"
			:isDialogActive="isShowRequestFormDialogMixin"
			:key="activeRequestMixin && activeRequestMixin.id ? activeRequestMixin.id : 'default'"
			@closeDialog="toggleRequestFormDialogMixin"
			@onIsFormDirtyChange="handleSetIsFormDirty"
			@onChangeRequestType="handleChangeRequestTypeMixin"
			@onClickSubmit="handleClickSubmitRequestFormDialog"
			@onFocusSelectRequestTypes="handleOnFocusSelectRequestTypesMixin"
		/>

		<div class="dropdown-button-container flex justify-end md:hidden lg:hidden xl:hidden" v-if="!isQuickMode">
			<vs-input @input="mixinHandleSearch" size="large" class="input-search mr-3" icon="search" :placeholder="$t('Actions.Search')" v-model="searchText" />

			<vs-dropdown vs-custom-content vs-trigger-click>
				<vs-button class="btn-drop" type="filled" icon="expand_more"></vs-button>
				<vs-dropdown-menu>
					<vs-dropdown-item>
						<vs-button class="w-48 font-bold" type="border" @click="toggleFilterDialog(true)">{{ $t("Filter") }}</vs-button>
					</vs-dropdown-item>
					<vs-dropdown-item v-if="mixinIsCanCreateTodo">
						<vs-button class="w-48 font-bold" type="filled" @click="addNewData">{{ $t("Assigned") }}</vs-button>
					</vs-dropdown-item>
				</vs-dropdown-menu>
			</vs-dropdown>
		</div>

		<vs-table :sst="true" ref="table" class="stack-table todo-list-table" :noDataText="$t('Notify.NoDataAvailable')" :max-items="itemsPerPage" :data="todoList" @sort="mixinHandleSort">
			<div slot="header" class="w-full" v-if="!isQuickMode">
				<div class="flex flex-grow justify-end">
					<!-- <router-link exact :to="$constant.PAGES_PATH.PAGE_MISSION_OF_DAY_PATH" :title="$t('FullScreen')">
						<vs-button radius color="primary" type="flat" icon-pack="nucleo" icon="nucleo-scale-up"></vs-button>
					</router-link> -->
					<vs-input
						@input="mixinHandleSearch"
						size="large"
						class="input-search mr-3 md:block lg:block xl:block hidden"
						icon="search"
						:placeholder="$t('Actions.Search')"
						v-model="searchText"
					/>
					<div class="md:flex lg:flex xl:flex hidden">
						<vs-button class="w-48 font-bold" type="border" @click="toggleFilterDialog(true)">{{ $t("Filter") }}</vs-button>
						<vs-button class="w-48 font-bold ml-3" type="border" @click="toggleReportDialog(true)">{{ $t("Report") }}</vs-button>
						<div class="md:flex lg:flex xl:flex hidden ml-3" v-if="mixinIsCanCreateTodo">
							<vs-button class="w-48 font-bold" type="filled" @click="addNewData">{{ $t("Assigned") }}</vs-button>
						</div>
					</div>
				</div>
				<!-- Button Group -->
				<div class="flex flex-grow justify-between items-center mt-5 pb-5">
					<div class="flex flex-wrap flex-grow justify-start w-full md:gap-3 gap-2">
						<vs-button
							v-for="(tag, idx) in $store.state.todoListManagement.todolistCount"
							:key="`tag${idx}`"
							:color="isActiveTag(tag.id) ? '#2B59B2' : '#828282'"
							type="border"
							:class="['border-2', { 'font-bold': isActiveTag(tag.id), notActive: !isActiveTag(tag.id) }]"
							@click="handleClickTag(tag)"
						>
							<p :class="['whitespace-no-wrap', { 'text-primary': isActiveTag(tag.id) }]">{{ tag.name }} ({{ tag.content }})</p>
						</vs-button>
					</div>
					<div>
						<TodoSortContextMenu @onChangeSort="handleSort" />
					</div>
				</div>
			</div>

			<template v-if="todoListFilterFlagValue !== null" slot="thead">
				<vs-th class="no-sorter"></vs-th>
				<vs-th :sort-key="isQuickMode ? null : 'name'" :class="{ 'no-sorter': isQuickMode }">{{ $t("Name") }}</vs-th>
				<vs-th :sort-key="isQuickMode ? null : 'status'" :class="{ 'no-sorter': isQuickMode }">{{ $t("Status") }}</vs-th>
				<vs-th class="no-sorter">{{ $t("Deadline") }}</vs-th>
				<vs-th class="no-sorter" v-if="todoListFilterFlagValue !== $constant.TODO_FILTER_FLAG['created-by-me']">{{ $t("Creator") }}</vs-th>
				<vs-th class="no-sorter" v-if="todoListFilterFlagValue !== $constant.TODO_FILTER_FLAG['assigned-to-me'] && !isQuickMode">{{ $t("Employee") }}</vs-th>
				<!-- <vs-th class="no-sorter" v-if="todoListFilterFlagValue === $constant.TODO_FILTER_FLAG['assigned-to-me'] || isQuickMode">{{ $t("ParentTodo") }}</vs-th> -->
				<vs-th class="no-sorter" v-if="!isQuickMode && (!todoListFilterFlagValue || todoListFilterFlagValue !== $constant.TODO_FILTER_FLAG['assigned-to-me'])">
					{{ categoryId === 1 ? $t("Device") : $t("Relations") }}
				</vs-th>
				<vs-th class="no-sorter">{{$t("ReviewLevel")}}</vs-th>
				<vs-th class="no-sorter"></vs-th>
			</template>

			<template slot-scope="{ data }">
				<div v-if="todoListFilterFlagValue === null">
					<div v-for="(todoParentItem, indx) in data" :key="`todoParentItem${indx}`">
						<TodoParentCollapseItem
							v-if="todoParentItem && !todoParentItem.parent"
							:ref="`parentTodoListItem${todoParentItem.id}`"
							:todo="todoParentItem"
							:filters="filters"
							@onClickEdit="editData"
							@viewDetail="viewDetail"
							@onClickRecreate="editData"
							@onSetStatusTodo="setStatusTodo"
							@onClickWatcher="handleClickWatcher"
							@onCompleteTodo="handleCompleteTodo"
							@onClickReminder="handleClickReminder"
							@onSetMarkedColor="handleSetMarkedColor"
							@onClickCancel="handleClickCancelTodoItem"
							@onClickReject="handleClickRejectTodoItem"
							@onClickCreateRequest="handleClickCreateRequest"
							@onClickToggleScheduleTodo="handleToggleScheduleTodo"
							@onClickAddDetail="handleClickQuickConfigChildrenTodoItem"
							@onClickCreateClone="handleCreateClone"
							@onClickSettingTimeRepeater="handleSettingTimeRepeater"
						/>
					</div>
				</div>
				<tbody v-else>
					<vs-tr
						:data="tr"
						:key="`${indextr}-${tr.updated_at}`"
						:class="[
							'todo',
							{
								'todo--just-completed': tr.id === completedTodoId
							}
						]"
						v-for="(tr, indextr) in data"
						@click.native="handleClickTodoItemRow($event, tr)"
					>
						<vs-td class="lg:w-4">
							<div class="flex items-center">
								<cbs-color-picker
									:ref="`colorPickerRef-${tr.id}`"
									:value="tr.userOptionColor"
									mode="flag"
									:colors="noteColors"
									:listHeaderText="''"
									@input="color => handleSetMarkedColor(tr.id, color)"
								/>
							</div>
						</vs-td>

						<!-- <vs-td :data-header="$t('Priority')" class="lg:w-4">
							<span :class="['font-bold todo-item-priority font-medium']">
								<i
									:class="[
										{
											'nucleo-priority-S1': tr.readableProperties.priority === 0,
											'nucleo-priority-S2': tr.readableProperties.priority === 1,
											'nucleo-priority-S3': tr.readableProperties.priority === 2,
											'nucleo-priority-S4': tr.readableProperties.priority === 3
										},
										'nucleo text-4xl text-gray-3'
									]"
								></i>
							</span>
						</vs-td> -->

						<vs-td :data-header="$t('Name')">
							<h5 class="text-base text-black todo-item-name font-normal">{{ tr.name }}</h5>
							<h5 class="text-base todo-item-parent-name font-normal text-gray-2" v-if="tr.parent && tr.parent.name">{{ tr.parent.name }}</h5>
						</vs-td>

						<vs-td :data-header="$t('Status')">
							<p :class="['font-bold todo-item-status font-medium']">
								<span v-if="tr.type === $constant.TODO_TYPE.NORMAL" :class="[renderStatusColor(tr.status_object.key)]">
									{{ tr.status_object.value }}
								</span>
								<span v-else :class="['font-bold', tr.readableProperties.schedule_enable ? 'text-primary' : 'text-danger']">
									{{ tr.readableProperties.schedule_enable ? $t("Repeater.TurnedOn") : $t("Repeater.TurnedOff") }}
								</span>
							</p>
						</vs-td>

						<vs-td :data-header="$t('Deadline')">
							<p :class="['todo-item-deadline font-medium', { 'text-over-time': tr.is_over_due }]">{{ tr.readableProperties.deadline | dateTime(userDateTimeFormat) }}</p>
							<p :class="['todo-item-deadline font-medium']">{{ tr.done_at | dateTime(userDateTimeFormat) }}</p>
						</vs-td>

						<vs-td :data-header="$t('Creator')" v-if="todoListFilterFlagValue !== $constant.TODO_FILTER_FLAG['created-by-me']">
							<p v-if="tr.creater" class="todo-item-employee font-medium">
								{{ tr.creater.first_name }}
							</p>
						</vs-td>

						<vs-td :data-header="$t('Employee')" v-if="todoListFilterFlagValue !== $constant.TODO_FILTER_FLAG['assigned-to-me'] && !isQuickMode">
							<p v-for="(assignee, idx) in tr.assignees" :key="`${assignee.id}${idx}`" class="todo-item-employee font-medium flex items-center">
								<cbs-relation-icon class="self-start" :type="assignee.type" />
								<span>{{ assignee.name }}</span>
							</p>
						</vs-td>

						<!-- <vs-td :data-header="$t('ParentTodo')" v-if="todoListFilterFlagValue === $constant.TODO_FILTER_FLAG['assigned-to-me'] || isQuickMode">
							<p class="todo-item-parent-name font-medium" v-if="tr.parent && tr.parent.name">{{ tr.parent.name }}</p>
						</vs-td> -->

						<vs-td
							:data-header="categoryId === 1 ? $t('Device') : $t('Relations')"
							v-if="!isQuickMode && (!todoListFilterFlagValue || todoListFilterFlagValue !== $constant.TODO_FILTER_FLAG['assigned-to-me'])"
						>
							<div v-if="tr.relations && tr.relations.length">
								<DisplayRelations class="flex flex-col" :relations="tr.relations" />
							</div>
						</vs-td>

						<vs-td>
							<div class="w-1/5">
								<div class="flex items-center h-full" v-if="hasReview(tr)">
									<i :style="{fontSize: '1.5rem', cursor: 'pointer', color: checkReview(tr, 1) ? '#F2994A' : '#828282'}" class="nucleo nucleo-priority-S1"/>
									<i :style="{fontSize: '1.5rem', cursor: 'pointer', color: checkReview(tr, 2) ? '#F2994A' : '#828282'}" class="nucleo nucleo-priority-S1"/>
									<i :style="{fontSize: '1.5rem', cursor: 'pointer', color: checkReview(tr, 3) ? '#F2994A' : '#828282'}" class="nucleo nucleo-priority-S1"/>
									<i :style="{fontSize: '1.5rem', cursor: 'pointer', color: checkReview(tr, 4) ? '#F2994A' : '#828282'}" class="nucleo nucleo-priority-S1"/>
									<i :style="{fontSize: '1.5rem', cursor: 'pointer', color: checkReview(tr, 5) ? '#F2994A' : '#828282'}" class="nucleo nucleo-priority-S1"/>
								</div>
							</div>
						</vs-td>

						<vs-td class="whitespace-no-wrap text-right">
							<TodoItemContextMenu
								type="vertical"
								:todoItem="tr"
								@onClickEdit="editData"
								@onClickRecreate="editData"
								@onSetStatusTodo="setStatusTodo"
								@onClickWatcher="handleClickWatcher"
								@onCompleteTodo="handleCompleteTodo"
								@onClickReminder="handleClickReminder"
								@onClickCancel="handleClickCancelTodoItem"
								@onClickReject="handleClickRejectTodoItem"
								@onClickCreateRequest="handleClickCreateRequest"
								@onClickToggleScheduleTodo="handleToggleScheduleTodo"
								@onClickAddDetail="handleClickQuickConfigChildrenTodoItem"
								@onClickCreateClone="handleCreateClone"
								@onClickSettingTimeRepeater="handleSettingTimeRepeater"
							/>
						</vs-td>
					</vs-tr>
				</tbody>
			</template>
		</vs-table>

		<CbsPagination class="mt-3" :total="totalPages" v-model="currentPage" />
		<todo-filter
			ref="todoFilters"
			v-model="filters"
			:isDialogActive="showFilterDialog"
			:todoFilterFlagValue="todoListFilterFlagValue"
			@closeDialog="toggleFilterDialog"
			@onApplyFilter="handleApplyFilter"
		/>
		<todo-report
			ref="todoReport"
			v-model="reports"
			:isDialogActive="showReportDialog"
			:todoFilterFlagValue="todoListFilterFlagValue"
			@closeDialog="toggleReportDialog"
			@onApplyFilter="handleApplyReport"
		/>
		<TodoCancelConfirmDialog :isDialogActive="isShowTodoCancelConfirmDialog" @onClickAgree="handleCancelTodoItem" @closeDialog="toggleTodoCancelConfirmDialog" />
		<TodoRejectConfirmDialog :isDialogActive="isShowTodoRejectConfirmDialog" @onClickAgree="handleRejectTodoItem" @closeDialog="toggleTodoRejectConfirmDialog" />
		<TodoReminderDialog
			v-if="isReminderTodoDialogActive"
			:todo="reminderTodoDialogData"
			:isSidebarActive="isReminderTodoDialogActive"
			@closeSidebar="toggleReminderSidebar"
			@onUpdateReminderSuccess="handleUpdateReminderSuccess"
		/>
		<TodoWatcherDialog
			v-if="isWatcherTodoDialogActive"
			:todo="watcherTodoDialogData"
			:isSidebarActive="isWatcherTodoDialogActive"
			@closeSidebar="toggleWatcherSidebar"
			@onUpdateWatcherSuccess="handleUpdateReminderSuccess"
		/>
		<todo-quick-config-children-dialog
			v-if="isShowQuickConfigChildrenTodo"
			v-model="quickConfigChildrenTodoData"
			:isDialogActive="isShowQuickConfigChildrenTodo"
			@onSubmit="handleUpdateChildrenTodoData"
			@closeDialog="toggleQuickConfigChildrenTodo"
			@onClickAddTodoItem="handleClickAddChildTodo"
			@onClickRemoveTodoItem="handleRemoveChildTodoData"
		/>
	</div>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import { mapGetters } from "vuex";
import requestGQL from "@/http/requests/request/request_v2_gql";
import requestBasicHandlers from "@/mixins/requestBasicHandlers";
import { todoPermissions, withBasicQueries, getUserPermissions, detectLeavePage, showConfirm } from "@/mixins/mixins.js";

import TodoFilter from "./TodoFilter";
import TodoReport from "./TodoReport.vue";
import TodoDetailSidebar from "./TodoDetailSidebar";
import TodoWatcherDialog from "./TodoWatcherDialog";
import TodoReminderDialog from "./TodoReminderDialog";
import TodoItemContextMenu from "./TodoItemContextMenu";
import TodoListFormSidebar from "./TodoListFormSidebar";
import TodoParentCollapseItem from "./TodoParentCollapseItem";
import TodoCancelConfirmDialog from "./TodoCancelConfirmDialog";
import TodoRejectConfirmDialog from "./TodoRejectConfirmDialog";
import TodoQuickConfigChildrenDialog from "./TodoQuickConfigChildrenDialog";
import CbsColorPicker from "@/components/cbs-color-picker/CbsColorPicker";
import RequestFormDialog from "@/components/cbs-request/RequestFormDialog";
import DisplayRelations from "@/components/display-relations/DisplayRelations";
import TodoSortContextMenu from "./TodoSortContextMenu";

const initChildTodoItemData = {
	name: "",
	watchers: [],
	assignees: [],
	properties: null
};

export default {
	mixins: [withBasicQueries, requestBasicHandlers, getUserPermissions(todoPermissions), detectLeavePage("isRequestFormDirty"), showConfirm],
	components: {
		TodoFilter,
		TodoReport,
		CbsColorPicker,
		DisplayRelations,
		TodoDetailSidebar,
		RequestFormDialog,
		TodoWatcherDialog,
		TodoReminderDialog,
		TodoListFormSidebar,
		TodoItemContextMenu,
		TodoParentCollapseItem,
		TodoCancelConfirmDialog,
		TodoRejectConfirmDialog,
		TodoQuickConfigChildrenDialog,
		TodoSortContextMenu
	},
	props: {
		isQuickMode: Boolean
	},
	data() {
		return {
			itemsPerPage: 10,
			cancelTodoId: null,
			rejectTodoId: null,
			relationsDataId: null,
			completedTodoId: null,

			// Data Sidebar
			todoFormDialogData: {},
			isTodoFormDialogActive: false,
			detailTodoDialogData: {},
			isDetailTodoDialogActive: false,
			quickConfigChildrenTodoData: {},
			isShowQuickConfigChildrenTodo: false,

			// currentPage: 1,
			listOrderBy: [{ column: "id", direction: "desc" }],
			categoryId: Number(this.$route.query.categoryId),
			showFilterDialog: false,
			showReportDialog: false,
			filters: {
				type: null,
				from_start_date: null,
				to_start_date: null,
				from_deadline: null,
				to_deadline: null,
				assignees: [],
				relations: [],
				creator_employee_id: null,
				statuses: []
			},
			reports: {
				from_start_date: null,
				to_start_date: null,
				relations: [],
			},

			isRequestFormDirty: false,
			isShowTodoCancelConfirmDialog: false,
			isShowTodoRejectConfirmDialog: false,
			isReminderTodoDialogActive: false,
			reminderTodoDialogData: null,
			parentData: null,
			isWatcherTodoDialogActive: false,
			watcherTodoDialogData: null,
			activeTag: [],
			limitPerPage: this.$store.state.todoListManagement.limitPerPage
		};
	},
	computed: {
		...mapGetters({
			getParsedTodoList: "todoListManagement/getParsedTodoList"
		}),
		todoList() {
			return this.getParsedTodoList || [];
		},
		todoListChild() {
			return this.$store.state.todoListManagement.todoListChild || [];
		},
		totalPages() {
			return Math.ceil(this.$store.state.todoListManagement.totalTodoList / this.limitPerPage);
		},
		relationsData() {
			return [
				{
					id: this.relationsDataId,
					type: this.$constant.RELATION_MODELS.TODO
				}
			];
		},
		todoListFilterFlag() {
			const routePath = this.$route && this.$route.path;
			if (
				routePath === this.$constant.PAGES_PATH.PAGE_CBS_MY_TODO_PATH ||
				routePath === this.$constant.PAGES_PATH.PAGE_CBS_MY_CREATED_TODO_PATH ||
				routePath === this.$constant.PAGES_PATH.PAGE_CBS_MY_FOLLOWING_TODO_PATH ||
				routePath === this.$constant.PAGES_PATH.PAGE_CBS_MY_SCHEDULE_TODO_PATH
			) {
				const filterType = routePath && routePath.split("/");
				return filterType && filterType.length && filterType[filterType.length - 1];
			}
			return null;
		},
		todoListFilterFlagValue() {
			if (this.todoListFilterFlag) {
				return this.$constant.TODO_FILTER_FLAG[this.todoListFilterFlag] || null;
			}
			return null;
		},
		noteColors() {
			return this.$constant.PICKER_MARK_COLORS || [];
		}
	},
	watch: {
		currentPage() {
			this.getTodoList();
		},
		$route(newVal, oldVal) {
			const newValClone = Object.assign({}, newVal);
			const oldValClone = Object.assign({}, oldVal);
			if (newValClone.path !== oldValClone.path) {
				this.$refs.todoFilters.handleResetLocalFilter();
				this.filters = {
					type: null,
					from_start_date: null,
					to_start_date: null,
					from_deadline: null,
					to_deadline: null,
					assignees: [],
					relations: [],
					creator_employee_id: null,
					statuses: [-1],
					department_ids: []
				};
			}
		},
		"$route.query"(newVal, oldVal) {
			const newValClone = Object.assign({}, newVal);
			const oldValClone = Object.assign({}, oldVal);
			this.categoryId = newValClone.categoryId && newValClone.categoryId != "" ? Number(newValClone.categoryId) : this.$route.path === "/app/todo-list-devices" ? 1 : 0;

			delete oldValClone.id;
			delete newValClone.id;
			delete oldValClone.is_child;
			delete newValClone.is_child;

			if (!_.isEqual(newValClone, oldValClone)) {
				this.handleFetchDataByQuery();
			}
		},
		"$route.query.id"(newVal, oldVal) {
			if (Number(newVal) !== Number(oldVal) && this.$route.query.id) {
				this.viewDetail({ id: this.$route.query.id });
			}
		},
		isShowRequestFormDialogMixin() {
			if (!this.isShowRequestFormDialogMixin) {
				this.handleSetIsFormDirty(false);
			}
		},
		"$route.params"(newVal, oldVal) {
			if (newVal !== oldVal) {
				const params = { ...oldVal, ...newVal };
				this.filters.department_ids = params.department_ids ? params.department_ids : [];
				this.handleFetchDataByQuery();
			}
		}
	},
	methods: {
		hasReview(todo) {
			let props = JSON.parse(todo.properties);
			return props && props.hasOwnProperty('review');
		},
		checkReview(todo, num) {
			let props = JSON.parse(todo.properties);
			let review = 0;
			if (props && props.hasOwnProperty('review')) {
				review = parseInt(props.review);
			}
			if (review) {
				return parseInt(review) >= num;
			}
			return false;
		},
		async getTodoList(isRefetch = false) {
			try {
				const employee_id = this.$store.state.AppActiveUser.employee_id;
				this.$vs.loading();
				const queryOptions = {
					limit: this.limitPerPage,
					page: this.currentPage,
					listOrderBy: this.listOrderBy,
					// if flag was schedule-by-me (-1) set flag was created-by-me to filter only todo created by user
					flag: this.todoListFilterFlagValue !== -1 ? this.todoListFilterFlagValue : 1,
					...this.filters,
					type: 0
				};

				if (this.filters.type === this.$constant.TODO_TYPE.NORMAL) {
					queryOptions.is_child = false;
				}
				if (this.filters.type === this.$constant.TODO_TYPE.SCHEDULE) {
					queryOptions.is_child = true;
				}
				if (this.filters.type === null) {
					queryOptions.is_child = null;
				}

				if (this.isQuickMode) {
					queryOptions.limit = 5;
					this.limitPerPage = 5;
					queryOptions.flag = this.$constant.TODO_FILTER_FLAG["assigned-to-me"];
				}

				if (isRefetch) {
					queryOptions.fetchPolicy = "no-cache";
				}

				if (this.searchText) {
					queryOptions.search = this.searchText;
				}
				if (this.todoListFilterFlagValue !== null) {
					queryOptions.parent_id = -1;
					this.$store.dispatch("todoListManagement/resetDataTodoListChild");
				}
				queryOptions.creator_employee_id = this.filter && this.filter.creator_employee_id ? this.filter.creator_employee_id : employee_id;

				// Fetch todoList
				await this.$store.dispatch("todoListManagement/fetchTodoListManagement", queryOptions);
				if (this.$refs.table && this.searchText) {
					this.$refs.table.currentx = 1;
				}
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		addNewData() {
			this.parentData = null;
			this.todoFormDialogData = {};
			this.toggleDataSidebar(true);
		},
		async editData(id) {
			try {
				this.$vs.loading();
				const response = await this.getTodoItem(id);

				const parsedProperties = _.get(response, "properties") ? JSON.parse(_.get(response, "properties")) : {};

				this.todoFormDialogData = {
					...response,
					is_done: _.get(parsedProperties, "is_done") || false,
					description: _.get(response, "description") || null,
					employee_id: _.get(response, "employees.0.id") || null,
					device_id: _.get(parsedProperties, "device_id") || null,
					device_name: _.get(parsedProperties, "device_name") || "",
					priority: _.get(parsedProperties, "priority") || 0,
					review: _.get(parsedProperties, "review") || 0,
					deadline: _.get(parsedProperties, "deadline") || ""
				};
				this.toggleDataSidebar(true);
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		toggleDataSidebar(val = false) {
			this.isTodoFormDialogActive = val;
		},
		toggleDetailSidebar(val = false) {
			if (!val) {
				const routeQuery = this.$route.query || {};
				let nextDetailId = null;
				if (routeQuery.id && routeQuery.is_child) {
					this.$router.back();
					nextDetailId = routeQuery.id || null;
				}
				this.detailId = nextDetailId;
			}
			this.isDetailTodoDialogActive = val;
		},
		async viewDetail(todo) {
			try {
				this.$vs.loading();
				this.detailTodoDialogData = await this.getTodoItem(todo.id);
				if (!this.detailTodoDialogData) {
					this.$helper.notifyError({
						context: this,
						options: {
							text: this.$t("TodoItemNotFound")
						}
					});
				} else {
					this.toggleDetailSidebar(true);
				}
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
				const routeQuery = { ...this.$route.query };
				delete routeQuery.id;
				delete routeQuery.is_child;
				this.$router.replace({ query: routeQuery });
			} finally {
				this.$vs.loading.close();
			}
		},
		async getTodoItem(id) {
			try {
				this.$vs.loading();
				const dataTodo = await this.$store.dispatch("todoListManagement/getTodoItem", id);
				if (dataTodo) {
					return this.parsedTodo(dataTodo);
				}
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		parsedTodo(todo) {
			return this.$store.getters["todoListManagement/getParsedTodo"](todo);
		},
		handleFetchDataByQuery() {
			this.getTodoList();
		},
		toggleFilterDialog(val = false) {
			this.showFilterDialog = val;
		},
		toggleReportDialog(val = false) {
			this.showReportDialog = val;
		},
		handleApplyFilter(data) {
			this.filters = Object.assign(this.filters, data);
			this.currentPage = 1;
			this.activeTag = this.filters.statuses ? this.filters.statuses : [];
			this.getTodoList();
		},
		handleApplyReport(data) {
			this.reports = Object.assign(this.reports, data);
			console.log(this.reports);
			this.toggleReportDialog();
			let activeUser = this.$store.state.AppActiveUser;
			if (activeUser && activeUser.employee_id) {
				this.reports.employee_id = activeUser.employee_id;
			}
			fetch(process.env.VUE_APP_GRAPHQL_DEFAULT_ENDPOINT + "/thong-ke-cong-viec", {
				method: "POST",
				headers: {'Content-Type': 'application/json'},
				body: JSON.stringify(this.reports)
			})
			.then(response => response.json())
			.then(res => {
				if (res && res.url) {
					window.location = process.env.VUE_APP_GRAPHQL_DEFAULT_ENDPOINT + res.url;
				}
			});
		},
		async handleOnUpdateRequest() {
			this.toggleRequestFormDialogMixin(false);
			this.detailTodoDialogData = await this.getTodoItem(this.relationsDataId);
		},
		handleSetIsFormDirty(isFormDirty) {
			this.isRequestFormDirty = isFormDirty;
		},
		handleClickCreateRequest(todoId) {
			this.handleSetInitRequestFormDialogMixin();
			this.relationsDataId = todoId;
			this.toggleRequestFormDialogMixin(true);
		},
		handleClickCancelTodoItem(todoId) {
			this.cancelTodoId = todoId;
			this.toggleTodoCancelConfirmDialog(true);
		},
		toggleTodoCancelConfirmDialog(val = false) {
			this.isShowTodoCancelConfirmDialog = val;
		},
		async handleCancelTodoItem(cancelReason) {
			try {
				this.$vs.loading();
				await this.$store.dispatch("todoListManagement/cancelTodoItem", {
					id: this.cancelTodoId,
					cancel_reason: cancelReason
				});

				this.$helper.notifySuccess({
					context: this,
					options: {
						text: this.$t("CancelTodoSuccessful")
					}
				});
				this.toggleTodoCancelConfirmDialog();
				if (this.isDetailTodoDialogActive) {
					this.toggleDetailSidebar();
				}
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		handleClickTodoItemRow(event, todoItem) {
			const eventClasses = event.target && event.target.className;
			// show detail dialog if click target is not below classes
			if (event.target !== event.currentTarget && !eventClasses.split(" ").find(className => ["cbs-context-menu", "cbs-color-picker", "item-relation--link"].includes(className))) {
				this.detailId = Number(todoItem.id);
			}
		},
		// Reject Todo
		handleClickRejectTodoItem(todoId) {
			this.rejectTodoId = todoId;
			this.toggleTodoRejectConfirmDialog(true);
		},
		toggleTodoRejectConfirmDialog(val = false) {
			this.isShowTodoRejectConfirmDialog = val;
		},
		async handleRejectTodoItem(rejectReason) {
			try {
				this.$vs.loading();
				const payload = {
					id: this.rejectTodoId,
					status: this.$constant.TODO_ITEM_STATUSES.STATUS_REJECTED,
					info: rejectReason
				};
				await this.$store.dispatch("todoListManagement/setStatusTodo", payload);
				this.$helper.notifySuccess({
					context: this,
					options: {
						text: this.$t("RejectTodoSuccessful")
					}
				});
				this.toggleTodoRejectConfirmDialog();
				if (this.isDetailTodoDialogActive) {
					this.toggleDetailSidebar();
				}
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		async onCreateOrUpdateTodoItemSuccess(todoId) {
			if (todoId) {
				let todoIdToUpdate = todoId;
				if (this.isDetailTodoDialogActive) {
					if (this.detailTodoDialogData.id != todoId) {
						todoIdToUpdate = this.detailTodoDialogData.id;
					}
				}
				const todoResponeData = await this.getTodoItem(todoIdToUpdate);
				this.detailTodoDialogData = todoResponeData;
				this.$store.dispatch("todoListManagement/updateTodoItemLocal", todoResponeData);
			}
		},
		async handleOnCompleteReportTodoItem(todoId) {
			this.completedTodoId = todoId;
			setTimeout(() => {
				this.completedTodoId = null;
			}, 3000);
			await this.onCreateOrUpdateTodoItemSuccess(todoId);
			this.toggleDetailSidebar();
		},
		handleUpdateReportFormTodoItem(updatedReportForm) {
			this.detailTodoDialogData = {
				...this.detailTodoDialogData,
				forms: this.detailTodoDialogData.forms.map(form => {
					if (form.id === updatedReportForm.id) {
						return { ...updatedReportForm };
					}
					return form;
				})
			};
		},
		async handleSetMarkedColor(todoId, value) {
			try {
				this.$vs.loading();
				await this.$store.dispatch("todoListManagement/setMarkedColor", {
					color: value,
					optionable_id: todoId,
					optionable_type: this.$constant.USER_OPTION_TYPE.TODO
				});

				const colorPickerRef = this.$refs[`colorPickerRef-${todoId}`];
				if (colorPickerRef) {
					colorPickerRef[0].$el.click();
				}
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$nextTick(() => this.$vs.loading.close());
			}
		},

		async handleClickReminder(id) {
			try {
				this.$vs.loading();
				this.reminderTodoDialogData = await this.getTodoItem(id);
				if (!this.reminderTodoDialogData) {
					this.$helper.notifyError({
						context: this,
						options: {
							text: this.$t("TodoItemNotFound")
						}
					});
				} else {
					this.toggleReminderSidebar(true);
				}
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		toggleReminderSidebar(val) {
			this.isReminderTodoDialogActive = val;
		},
		async handleUpdateReminderSuccess() {
			if (this.isDetailTodoDialogActive) {
				this.detailTodoDialogData = await this.getTodoItem(this.detailTodoDialogData.id);
			}
		},

		formatStepConfigData(configData) {
			return {
				content: _.get(configData, "content"),
				relations: (_.get(configData, "relations") || []).map(option => ({ id: option.id, type: option.type }))
			};
		},
		async handleClickSubmitRequestFormDialog(requestData, dynamicStepConfig, relationsData, resolve) {
			try {
				this.$vs.loading();
				const mappedFormData = {};
				requestData.activeFormData.controls.forEach(field => {
					mappedFormData[field.id] = field.value;
					if (field.control === this.$constant.request.control.datetime && field.value) {
						mappedFormData[field.id] = moment(field.value).isValid() ? moment(field.value).toISOString() : field.value;
					}
					if (!_.isEmpty(field.value) && field.control === this.$constant.request.control.relation && field.value.every(item => typeof item === "object")) {
						mappedFormData[field.id] = field.value.map(item => item.id);
					}
				});

				const payload = {
					id: requestData.id,
					req_type_id: requestData.req_type_id,
					req_status_id: requestData.req_status_id,
					request_reason: requestData.request_reason,
					data: JSON.stringify(mappedFormData)
				};

				const selectedRequestType = this.requestTypesMixin.find(requestType => requestType.id === requestData.req_type_id) || {};
				const isDynamicRequest =
					(requestData && !requestData.id && selectedRequestType && selectedRequestType.statuses && _.isEmpty(selectedRequestType.statuses)) ||
					(requestData && requestData.id && requestData.is_dynamic);
				if (isDynamicRequest) {
					payload.step_status = {
						name: dynamicStepConfig.name,
						notifications: {
							approvers: this.formatStepConfigData(_.get(dynamicStepConfig, "config.approversConfig")),
							reject_notifications: this.formatStepConfigData(_.get(dynamicStepConfig, "config.rejectedNotificationConfig")),
							approve_notifications: this.formatStepConfigData(_.get(dynamicStepConfig, "config.approvedNotificationConfig"))
						}
					};
				}

				const response = await requestGQL.submitRequest({
					...payload,
					relations: relationsData
				});
				resolve(response);
				this.handleOnUpdateRequest();
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$nextTick(() => this.$vs.loading.close());
			}
		},
		async handleToggleScheduleTodo(data) {
			try {
				this.$vs.loading();
				await this.$store.dispatch("todoListManagement/toggleScheduleTodolist", {
					...data
				});
				if (this.isDetailTodoDialogActive) {
					this.detailTodoDialogData = await this.getTodoItem(this.detailTodoDialogData.id);
				}
				this.$helper.notifySuccess({
					context: this,
					options: {
						text: `${data.enable ? this.$t("EnableSchedule") : this.$t("DisableSchedule")} ${this.$t("Successful").toLowerCase()}`
					}
				});
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$nextTick(() => this.$vs.loading.close());
			}
		},
		async handleRefectchDataList() {
			if (this.parentData) {
				// await this.getTodoList(true);
				this.$refs[`parentTodoListItem${this.parentData.id}`][0].reFetchChilds(this.parentData.id, this.parentData.name);
			} else {
				this.getTodoList(true);
			}
		},
		toggleWatcherSidebar(val) {
			this.isWatcherTodoDialogActive = val;
		},
		async handleClickWatcher(id) {
			try {
				this.$vs.loading();
				this.watcherTodoDialogData = await this.getTodoItem(id);
				if (!this.watcherTodoDialogData) {
					this.$helper.notifyError({
						context: this,
						options: {
							text: this.$t("TodoItemNotFound")
						}
					});
				} else {
					this.toggleWatcherSidebar(true);
				}
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		async setStatusTodo(dataId, statusKey) {
			try {
				this.$vs.loading();
				const payload = {
					id: dataId,
					status: statusKey
				};
				await this.$store.dispatch("todoListManagement/setStatusTodo", payload);
				await this.onCreateOrUpdateTodoItemSuccess(dataId);
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		async handleClickQuickConfigChildrenTodoItem(todoItem) {
			const detailTodoItem = await this.getTodoItem(todoItem.id);
			let todoItemChildren = detailTodoItem.children && detailTodoItem.children.length ? detailTodoItem.children : [];
			todoItemChildren = todoItemChildren.filter(todoItem => todoItem.can_update);
			if (todoItemChildren.length <= 0) {
				let _initChildTodoItemData = initChildTodoItemData;
				if (detailTodoItem.assignees && detailTodoItem.assignees.length === 1) {
					_initChildTodoItemData = { ..._initChildTodoItemData, ...{ assignees: detailTodoItem.assignees } };
				}
				todoItemChildren = [{ ..._initChildTodoItemData }];
			}

			this.quickConfigChildrenTodoData = {
				...detailTodoItem,
				children: todoItemChildren
			};

			this.isShowQuickConfigChildrenTodo = true;
		},
		toggleQuickConfigChildrenTodo(val) {
			this.isShowQuickConfigChildrenTodo = val;
		},
		handleClickAddChildTodo() {
			let _initChildTodoItemData = initChildTodoItemData;
			if (this.quickConfigChildrenTodoData.assignees && this.quickConfigChildrenTodoData.assignees.length === 1) {
				_initChildTodoItemData = { ..._initChildTodoItemData, ...{ assignees: this.quickConfigChildrenTodoData.assignees } };
			}
			this.quickConfigChildrenTodoData = {
				...this.quickConfigChildrenTodoData,
				children: [...(this.quickConfigChildrenTodoData.children || []), { ..._initChildTodoItemData }]
			};
		},
		handleRemoveChildTodoData(removeIndex) {
			this.quickConfigChildrenTodoData = {
				...this.quickConfigChildrenTodoData,
				children: this.quickConfigChildrenTodoData.children.filter((todoItem, index) => index !== removeIndex)
			};
		},
		async handleUpdateChildrenTodoData() {
			try {
				this.$vs.loading();
				const payload = this.quickConfigChildrenTodoData.children.map(todoItem => {
					let parsedTodo = {
						name: todoItem.name,
						parent_id: this.quickConfigChildrenTodoData.id,
						assignees: todoItem.assignees.map(assignee => ({ id: assignee.id, type: assignee.type }))
					};
					if (typeof todoItem.properties === "string") {
						const parsedProperties = JSON.parse(todoItem.properties);
						parsedTodo = {
							due_mode: parsedProperties.due_mode,
							due_unit: parsedProperties.due_unit,
							deadline: parsedProperties.deadline && parsedProperties.deadline !== "" ? moment(parsedProperties.deadline).toISOString() : null,
							due_value: parsedProperties.due_value,
							...parsedTodo
						};
					}
					if (todoItem.id) {
						parsedTodo.id = todoItem.id;
					}
					return parsedTodo;
				});

				await this.$store.dispatch("todoListManagement/updateMultipleTodoItem", payload);
				this.$helper.notifySuccess({
					context: this,
					options: {
						text: this.$t("UpdateTodoSuccessful")
					}
				});
				await this.onCreateOrUpdateTodoItemSuccess(this.quickConfigChildrenTodoData.id);
				this.toggleQuickConfigChildrenTodo();
				if (this.$refs[`parentTodoListItem${this.quickConfigChildrenTodoData.id}`] && this.$refs[`parentTodoListItem${this.quickConfigChildrenTodoData.id}`][0]) {
					this.$refs[`parentTodoListItem${this.quickConfigChildrenTodoData.id}`][0].reFetchChilds(this.quickConfigChildrenTodoData.id, this.quickConfigChildrenTodoData.name);
				}
				this.quickConfigChildrenTodoData = {};
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$nextTick(() => this.$vs.loading.close());
			}
		},
		handleCompleteTodo(dataId, statusKey) {
			const idx = _.findIndex(this.todoList, { id: dataId });
			if (idx !== -1) {
				if (this.todoList[idx].forms.length > 0) {
					this.$vs.dialog({
						acceptText: this.$t("Actions.Close"),
						color: "primary",
						title: this.$t("Notifications"),
						text: this.$t("FillFormBeforeDone")
					});
				} else {
					this.setStatusTodo(dataId, statusKey);
				}
			} else {
				const idxChild = _.findIndex(this.todoListChild, { id: dataId });
				if (idxChild !== -1) {
					if (this.todoListChild[idxChild].forms.length > 0) {
						this.$vs.dialog({
							acceptText: this.$t("Actions.Close"),
							color: "primary",
							title: this.$t("Notifications"),
							text: this.$t("FillFormBeforeDone")
						});
					} else {
						this.setStatusTodo(dataId, statusKey);
					}
				}
			}
		},
		handleClickTag(tag) {
			let statuses = _.cloneDeep(this.activeTag);
			const idx = _.indexOf(statuses, tag.id);
			if (idx !== -1) {
				statuses.splice(idx, 1);
			} else {
				statuses.push(tag.id);
			}
			this.handleApplyFilter({ statuses });
		},
		handleSort(sorts) {
			this.listOrderBy = sorts;
			this.getTodoList();
		},
		async handleCreateClone(id) {
			const isAccept = await this.mixinShowConfirm({
				text: `${this.$t("Notify.AreYouSure", { action: this.$t("CreateClone").toLowerCase() })}`
			});
			if (isAccept) {
				try {
					this.$vs.loading();
					const payload = {
						id: id
					};
					await this.$store.dispatch("todoListManagement/createCloneTodoItem", payload);
					this.$helper.notifySuccess({
						context: this,
						options: {
							text: `${this.$t("CreateClone")} ${this.$t("Successful").toLowerCase()}`
						}
					});
				} catch (error) {
					this.$helper.notifyError({ context: this, error });
				} finally {
					this.$nextTick(() => this.$vs.loading.close());
				}
			}
		},

		handleSettingTimeRepeater(todoItemScheduleId) {
			this.editData(todoItemScheduleId);
		},
		isActiveTag(id) {
			return _.includes(this.activeTag, id);
		}
	},
	created() {
		this.handleFetchDataByQuery();
		this.$store.dispatch("todoListManagement/getTodolistCount", {
			flag: this.todoListFilterFlagValue !== -1 ? this.todoListFilterFlagValue : 1
		});
		if (this.$route.query.id) {
			this.viewDetail({ id: this.$route.query.id });
		}
		this.$on("onClickEdit", data => {
			this.editData(data);
		});
	}
};
</script>

<style lang="scss">
#todo-list {
	.todo {
		&.todo--just-completed {
			td {
				border: 2px solid transparent;

				&:not(:first-child) {
					border-left: none;
				}

				&:first-child,
				&:not(:last-child) {
					border-right: none;
				}

				&:first-child,
				&:last-child {
					border-left-width: 3px;
					border-right-width: 4px;
				}

				animation: success-border-color 8s ease 0s 1;
			}
		}
	}
}
</style>
